export default {
  home: [
    {
      title: "FREEZE DRIED",
      subtitle:
        "YOU COULD FIND ALL DRIED FRUIT AND VEGETABLE WITH NATURAL INGREDIENTS",
      title1: "TOASTED DRIED",
      title2: "SEMI DRIED",
      title3: "VACUUM FRIED",
    },
    {
      title: "EXPLORE OUR PRODUCTS",
      button: "Specialize",
      item1: {
        title: "QUALITY CONTROL",
        text: "HACCP, BRC, ISO, HALAL certificated. A+ grade material are from trusted bases, registered in China Customs System.",
        description:
          "6 times selection process in each production: foreign body, color, shape, size, metal detection, broken ratio.",
      },
      item2: {
        title: "CUSTOMIZED PLAN",
        text: "One-stop OEM service to support brand clients: variety, color, shape, size, package etc.",
        description:
          "Customization solution for food manufacturing clients: baking, chocolate, cereal, ice cream, candy etc.",
      },
      item3: {
        title: "DEVELOPMENT",
        text: "16 people R&D team to support clients’ great ideas achievement: process method, ingredient list, new flavor etc.",
        description:
          "Communicate with brands STARBUCKS, AMWAY etc, to learn the trend of global snack market.",
      },
    },
    {
      item: {
        title: "EXPLORE OUR PRODUCTS",
        text: " Our company believe that natural ingredients could bring health to clients and consumers including kids, pregnant, elderly. We focus on the super foods supplying in high end process method: freeze dried, vacuum fried, toasted dried, semi dried etc, max keeping the nutrition of fresh fruit and vegetable.",
        description:
          " Natural, Vegan, Gluten free, Non-GMO, HALAL, No additive, No preservative, no artificial colors. Each ingredient of each product should be confirmed, natural.",
      },
      button: "Go To Brochures",
    },
    {
      title: "OUR CERTIFICATIONS",
    },
    {
      title: "OUR TEAM",
      text: "We believe that if we do more, clients could do less. That's how we build long term cooperation with each client. We are good at solving and avoiding problems to save the time and cost of clients.",
      description:
        " Everybody in Green Crispy is honest, hard working, keeping learning, keeping optimistic attitude, taking good care of each order. We regard client's business as ourselves thing. Together with us, everything will be better and easier. You can rest easy knowing that we will get the job done right.",
      button: "More About US",
    },
    {
      title: "COOPERATION PARINER",
    },
  ],
  qualityControl: [
    {
      item1: {
        title: "11111111",
        text: "11111111111",
      },
      item2: {
        title: "11111111111",
        text: "1111111111111",
      },
      item3: {
        title: "Automatic Production Machines",
        text: "There are five categories of facilities and machines, including freeze dried facility, vacuum fried facility, seasoning facility, disinfection facility and packaging facility, which includes automatic production facilities like packaging facility to partly replace manual operation.",
      },
      item4: {
        title: "Regular Lab Tests",
        text: "Not only test in factory lab, issuing COA to help clients know quality detail, also cooperate with global standard labs like: Merieux, Eurofins, SGS, to get the accurate test data and achieve food safety.",
      },
      item5: {
        title: "Strict Selection Process",
        text: "6 times selection process in each production from the following aspects: foreign body, color, shape, size, metal detection, broken ratio, to ensure the food safety and quality. ",
      },
    },
  ],
  cataLog: [
    "Freeze Dried Fruit",
    "Freeze-dried candy",
    "Vacuum Fried Vegetable",
    "Toasted Dried Fruit",
    "Semi Dried Product",
    "Hazelnut & Chestnut ",
    "VIEW PRODUCTS",
    "CATALOG",
  ],
  abouts: [
    {
      title1: "EXPLORE OUR PRODUCTS",
      title: "About Us",
      title2: "GLOBAL CLIENTS’ MAP",
      introduceInfo: [
        {
          title: "MISSION",
          text1:
            "Connect human civilization with healthy ood.Connect human civilization with healthy food.Connect human civilization with healthy",
          text2:
            "Build a trusted global supply chain of healthy food and be committed to the well-being, growth and success of clients and employees.",
        },
        {
          title: "VISION",
          text1:
            "Build a trusted global supply chain of healthy food and be committed to the well-being, growth and success of clients and employees.",
          text2:
            "Build a trusted global supply chain of healthy food and be committed to the well-being, growth and success of clients and employees.",
        },
        {
          title: "CORE VALUE",
          text1:
            "We are a client-centric and innovation-driven organization with integrity and virtue. We are a client-centric and innovation-driven organization with integrity and virtue. ",
          text2:
            "We are a client-centric and innovation-driven organization with integrity and virtue. We are a client-centric and innovation-driven organization with integrity and virtue. ",
        },
      ],
      jieshao: [
        { dw: "YEAR", js: "Establishment" },
        { dw: "PEOPIE", js: "Current employees" },
        { dw: "AREA", js: "Exporting Countries" },
        { dw: "MAIN TYPE", js: "Product System" },
        { dw: "ITEM", js: "Product Items" },
      ],
    },
  ],
  inspectionReport: [
    {
      title: "Inspection Report",
      down: "DOWN",
    },
  ],
  customizedSolution: [
    {
      list: [
        {
          title: "One-Stop OEM Solution For Snack Brands Clients",
          nrList: [
            "One-stop OEM service to support brand clients selling on platform like Amazon. We could supply professional service for brand client: stickers, bag design, bag print, display box, master carton etc. Whether you want to build a new brand or expand business, welcome to cooperate with us.s",
          ],
        },
        {
          title: "Ingredients Solution for Food Manufacturing",
          nrList: [
            "Ingredients solution for food manufacturing industries: baking, chocolate, ice cream, cereal, candy. We could develop new ingredients from: variety, shape, size, color to meet different food manufacturing.",
          ],
        },
        {
          title: "High Quality Package",
          nrList: [
            "We choose food grade aluminum foil bag. To keep less breakage during shipping, we add bubble wrap in carton. fragile sticker on carton, wrapping film and pallet to protect carton and make the lowest breakage. Before loading goods, we check, clean, reinforce container. Make sure safe shipping.",
          ],
        },
      ],
    },
  ],
  rd: [
    {
      list: [
        {
          title: "16 People R&D Team",
          nrList: [
            "Professional R&D team support clients’ great ideas achievement from process method, ingredient list, new flavor etc. 3 snacks are launched each month, helping clients expand market.",
          ],
        },
        {
          title: "Communicate With Glo",
          nrList: [
            "Keep contacting with brands such as STARBUCKS, AMWAY, MONDELEZ, communicating the trend of global snack market. Knowing the culture difference in each country, then provide suitable solution. ",
          ],
        },
      ],
    },
  ],
  cooperationCase: [
    {
      title: "QUALITY CONTROL",
      list: [
        {
          title:
            "Customized Solution For Vegetable Chips With Rice Bran Oil for UAE Market",
          nrList: [
            "In vacuum frying production, palm oil is widely used due to it’s stable performance. If consider health factor, palm oil is not be loved by consumers, because saturated fat is around 50% in palm oil.",
            "To provide a healthier solution for UAE clients, we tested all plant oil finally choose rice bran oil. Rice bran oil contain less saturated fat, around 20g per 100g, which has sweet taste and is better for heart, blood health. Vegetable chips contain less oil and has better crispy, better taste, better health.",
            "Customized Solution: Vacuum fried vegetable, rice bran oil",
          ],
          smtitle: "Vacuum Fried, UAE",
        },
        {
          title: "OEM Tempura Seaweed Chips for Australia Market",
          nrList: [
            "Seaweed chips are popular in global. But the taste is not enough because it’s thickness. Our team try many ways to explore how to make seaweed chips better tasty and crispy. After more than 20 tests, finally we developed vacuum fried tempura series for Australia clients, a perfect combination of tempura batter and seaweed. The best crispy and good seaweed taste. Don’t hesitate to try our wasabi flavor seaweed chips, it’s excellent.",
            "OEM Package method: 50g per unit, 6 units per display box, 6 boxes per carton",
          ],
          smtitle: "Vacuum Fried, Australia",
        },
        {
          title: "OEM Mix Vegetable Chips for Israel Market",
          nrList: [
            "When it comes to vegetable chips, consumers like eating different vegetable chips in one bag. Not only enjoy vegetable but also enjoy beautiful colors. Consumers like food with good look.",
            "We totally understand and professional at this. So we developed a variety of mixed vegetable chips for Israeli customers, different shapes, with salty, wasabi etc flavors. Considering health and taste, these vegetable chips are fried by rice bran oil. These bag designs are attractive, right? ",
            "OEM Package method: 40g per unit, 10 units in a transparent bag, 4 bags per carton",
          ],
          smtitle: "Vacuum Fried, Israel",
        },
        {
          title:
            "Customized Solution Low Maltose Mushroom Chips for Thailand Market",
          nrList: [
            "Maltose is a necessary ingredient in vacuum frying process, which is helpful for keeping the origin color, origin shape of fresh fruit, vegetable and mushrooms. But now, consumers do not like eating too much sugar in their diet, so we developed low maltose mushroom chips, to help consumers enjoy both tasty and healthy. You can’t find the difference from the shape, color, taste. When we look into the nutrition composition table, we could find sugar in a very low level. That’s great for consumers.",
            "Customized Solution: Vacuum fried mushroom, low maltose",
          ],
          smtitle: "Vacuum Fried, Thailand",
        },
        {
          title:
            "Customized Solution 1g Freeze Dried Yogurt for Thailand Granola Market",
          nrList: [
            "Freeze dried yogurt is good for granola products. How to evenly pack yogurt cubes into every bag granola, avoiding some bags have many freeze dried but some bags has less freeze dried yogurt ? According to Thailand client’s requirements, we developed freeze dried yogurt in 1g. Usually it’s 1.3g and 3g per block. Small size is helpful for client to put yogurt blocks evenly in each granola bag. Here are 5 flavors freeze dried yogurt available: strawberry, blueberry, mango, peach, dragon fruit.",
            "Customized Solution: Freeze dried yogurt, granola ",
          ],
          smtitle: "Freeze Dried, Thailand",
        },
      ],
    },
  ],
  control: [
    "QUALITY CONTROL",
    "REACH US",
    "Tianjin Green Crispy",
    "712, Wuyue Plaza B, Erba Road, Jinnan District, Tianjin, China,300350",
    "tyler@greencrispy.com",
    "+86 13512282858",
    "Monday to Friday - 9 am to 6 pm",
    "SOCIAL",
    "Send US A Message",
    "Name",
    "Email",
    "Message",
    "SEND",
  ],
  shopHome: [
    "Worth trying",
    "CONTACT FOR PRICE",
    "Global Food safety System",
    "Check Our Latest",
    "New Arrivals",
    "Show All Products",
    "Freeze Dried Product",
    "Vacuum Fried Product",
    "Toasted Dried Produc",
    "Hazelnut & Chestnut",
  ],
  shop: [
    {
      freezeDried: [
        "SHAPE FILTER",
        "WHOLE",
        "SLICE",
        "GRANULE",
        "POWDER",
        "SNACK (READY TO EAT)",
        "INGREDIENTS (FOOD MANUFACTURING)",
        "Hot Product",
        "Out Of Stock",
        "Get Price",
        "USAGE FILTER",
      ],
      vacuumFried: [
        "SHAPE FILTER",
        "Fruit",
        "Mushroom",
        "Snack",
        "Hot Product",
        "Out Of Stock",
      ],
      shopDetail: [
        "Size：",
        "Ingredient：",
        "Packing：",
        "Origin：",
        "ITEM CODE:",
        "CONTACT FOR PRICE",
      ],
    },
  ],
  components: [
    {
      footer: {
        title: ["CATEGORIES", "LINKS", "Contact Us", "Social Media", "home"],
        CATEGORIES: [
          "Freeze Dried",
          "Vacuum Fried",
          "SEMI DRIED",
          "TOASTED DRIED",
          "CANDY",
          "NUT",
        ],
        LINKS: [
          "Home",
          "About US",
          "Specialize",
          "Catalogs",
          "Cooperation Case",
          "Contact US",
        ],
        Contact: [
          "GREEN CRISPY",
          "+86 13512282858",
          "tyler@greencrispy.com",
          "712, Wuyue Plaza B, ErBa Road, JinNan District, Tianjin, China, 300350",
        ],
        Social: ["Instagram", "Facebook", "Whatsapp", "Linkedin"],
      },
      headerNav: [
        "HOME",
        "ABOUT US",
        "SPECIALIZE",
        "QUALITY CONTROL",
        "INSPECTION REPORT",
        "CUSTOMIZED SOLUTION",
        "R&D",
        "CATALOG",
        "COOPERATION CASE",
        "RCONTACT",
        "SHOP",
      ],
      headerNavDep: [
        "FREEZE DRIED",
        "VACUUM FRIED",
        "SEMI DRIED",
        "TOASTED DRIED",
        "CANDY",
        "NUT",
      ],
    },
  ],
};
